export default __webpack_public_path__ + "static/stake_pool@2x-78ea9c30f7cf6fa9b39b8605ac8002c5.png";